import React, { useState, useEffect } from "react";
import PrimaryEventSelector from "./PrimaryEventSelector";
import { Card } from "../../UI/DesignStandards";

const AllEventConfiguration = ({
  tournamentId,
  initialData = null,
  onChange,
  excludeEventId = null,
}) => {
  // Always use "first_attempt" for now - can be expanded later
  const SECONDARY_RULE_TYPE = "first_attempt";

  const [primaryEventIds, setPrimaryEventIds] = useState(
    initialData?.primaryEventIds || []
  );
  const [errors, setErrors] = useState({});

  // Load initial data if editing
  useEffect(() => {
    if (initialData) {
      setPrimaryEventIds(initialData.primaryEventIds || []);
    }
  }, [initialData]);

  // Notify parent of changes
  useEffect(() => {
    if (onChange) {
      onChange({
        primaryEventIds,
        secondaryRuleType: SECONDARY_RULE_TYPE,
        isValid: validate(),
      });
    }
  }, [primaryEventIds]);

  const validate = () => {
    const newErrors = {};
    let isValid = true;

    if (!primaryEventIds || primaryEventIds.length === 0) {
      newErrors.primaryEventIds = "At least one primary event must be selected";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handlePrimaryEventsChange = (newIds) => {
    setPrimaryEventIds(newIds);
    // Clear error when user makes a selection
    if (newIds.length > 0 && errors.primaryEventIds) {
      setErrors((prev) => ({ ...prev, primaryEventIds: null }));
    }
  };

  // Get display text for secondary rule
  const getSecondaryRuleDisplay = (ruleType) => {
    switch (ruleType) {
      case "first_attempt":
        return "First Attempt";
      default:
        return ruleType || "First Attempt";
    }
  };

  const displayRuleType = initialData?.secondaryRuleType || SECONDARY_RULE_TYPE;

  return (
    <Card className="mt-4">
      <div className="mb-4">
        <h3 className="text-sm font-display font-bold text-brand-charcoal">
          All Event Configuration
        </h3>        
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-brand-charcoal mb-2">
            Secondary Rule
          </label>
          <div className="px-3 py-2 border border-brand-charcoal/20 rounded-lg bg-brand-cream/80 text-brand-charcoal">
            {getSecondaryRuleDisplay(displayRuleType)}
          </div>
        </div>

        <PrimaryEventSelector
          tournamentId={tournamentId}
          value={primaryEventIds}
          onChange={handlePrimaryEventsChange}
          error={errors.primaryEventIds}
          excludeEventId={excludeEventId}
        />
      </div>
    </Card>
  );
};

export default AllEventConfiguration;
